var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0405 18.455C10.1142 18.3873 10.1726 18.307 10.2125 18.2185C10.2524 18.1301 10.2729 18.0353 10.2729 17.9395C10.2729 17.8438 10.2524 17.749 10.2125 17.6605C10.1726 17.5721 10.1142 17.4917 10.0405 17.424L1.81581 9.84903C1.66694 9.71214 1.58331 9.52654 1.58331 9.33302C1.58331 9.13951 1.66694 8.95392 1.81581 8.81703L10.0416 1.24403C10.1902 1.10718 10.2736 0.921668 10.2734 0.728318C10.2732 0.534968 10.1894 0.349615 10.0405 0.213028C9.89156 0.0764423 9.68966 -0.000186652 9.47923 3.50924e-07C9.2688 0.000188353 9.06706 0.0771691 8.91841 0.21402L0.695897 7.78703C0.250278 8.19757 3.0622e-05 8.75371 3.06289e-05 9.33353C3.06358e-05 9.91334 0.250278 10.4695 0.695897 10.88L8.92167 18.453C9.07005 18.5891 9.271 18.6657 9.48064 18.6661C9.69027 18.6665 9.89155 18.5906 10.0405 18.455Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.dbd836a7e227576c64b82d2f8c0a8d89.svg";
export { ForwardRef as ReactComponent };